import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <small>
        <a
          href="https://github.com/Roar95/react-weather-app-v2.git"
          target="_blank"
          rel="noreferrer"
        >
          Open-source code
        </a>
        {""} by Cressida Cox
      </small>
    </div>
  );
}
